import api from "@/apis/AssetTypeAPI";
import Crud from "./crud-base";
var crud = new Crud("AssetType", api);
import httpClient from "@/apis/base/axios-httpclient";

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "AssetTypeID",
      code: "AssetTypeCode",
      name: "AssetTypeName",
    },
  },
  tree: [],
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * load cây danh mục dùng cho màn hình danh sách tài sản
   */
  loadTree: async function (context, payload) {
    context.commit("updateLoading", true);

    let url = [api.getAPIUrl(), "tree"];
    if (payload == true) {
      url.push(true);
    }

    let request = {
      url: url.join("/"),
    };

    let res = await httpClient.getAsync(request);
    context.commit("updateLoading", false);

    if (res) {
      this.$ms.commonFn.setLocalStorage(treeCacheKey, JSON.stringify(res));
      context.commit("updateTree", res);
      return res;
    }
  },
};
const mutations = {
  ...crud.mutations,
  updateTree(state, res) {
    state.tree.removeAll();
    state.tree.append(res);
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
